import type { FC } from 'react';

interface Props {
  className?: string;
  svgString: string;
}

export const SvgStringToHtml: FC<Props> = ({ className, svgString }) => (
  <div
    className={className}
    dangerouslySetInnerHTML={{ __html: svgString }}
  />
);
